/**
 * Vue i18n
 *
 * @library
 *
 * https://vue-i18n.intlify.dev/
 */

// Lib imports
import messages from '@/lang';
import { createI18n } from 'vue-i18n';

// Composition API mode (legacy mode is deprecated in vue-i18n v11 and slated
// for removal). globalInjection keeps the existing call sites working unchanged
// — `$t` in templates and `this.$t` in class components.
const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'en',
  fallbackLocale: 'en',
  messages,
});

export default i18n;
